import http from 'utils/http';

/**
 *
 * @param data: email, password, remember, secret
 */
export const login = (data) => {
  return http('POST', 'auth/login', data);
};

export const post2FA = (data) => {
  return http('POST', 'auth/2fa', data);
};

export const loginOAuth = (data) => {
  return http('POST', 'auth/oauth', data);
};

export const getAuthSession = (sessionId) => {
  return http('GET', sessionId ? `auth/session/${sessionId}` : 'auth/session');
};

export const logout = () => {
  return http('POST', 'auth/logout');
};

export const forgot = (params) => {
  return http('POST', 'auth/forgot', params);
};

export const reset = (params) => {
  return http('POST', 'auth/reset', params);
};

export const getAuthResetToken = (token) => {
  return http('GET', `auth/reset/${token}`);
};

export const register = (params) => {
  return http('POST', 'auth/registration', params);
};

export const confirmRegistration = (token) => {
  return http('PUT', `auth/confirmation/${token}`);
};

/**
 * Accept Invitation by Token
 * @param data
 * @returns {*}
 */
export const authAcceptInvitation = (data) => {
  // Data includes the token.
  return http('POST', `auth/accept`, data);
};

/**
 * Validate Invitation Token
 * @param token
 * @returns {*}
 */
export const validateInvitationToken = (token) => {
  return http('GET', `auth/accept/${token}`);
};

/**
 * Accept Activation By Token
 * @param token
 * @param data
 * @returns {*}
 */
export const authAcceptActivationByToken = (token, data) => {
  return http('POST', `auth/activate/${token}`, data);
};

/**
 * Validate Activate Token
 * @param token
 * @returns {company}
 */
export const validateActivationToken = (token) => {
  return http('GET', `auth/activate/${token}`);
};

/**
 * Accept Activation by Company ID
 * @param companyId
 * @param data
 * @returns {*}
 */
export const authAcceptActivationById = (companyId, data) => {
  return http('POST', `auth/activate/c/${companyId}`, data);
};

/**
 * Send Activation Email to CB
 * @param cbId
 * @returns {*}
 */
export const sendCertificationBodyActivation = (cbId) => {
  return http('POST', `activation/cb/${cbId}`);
};

/**
 * Send Activation Email to Company (CE)
 * @param companyId
 * @returns {*}
 */
export const sendBranchActivation = (companyId) => {
  return http('POST', `activation/branch/${companyId}`);
};

export const sendBulkActivation = () => {
  return http('POST', `activation/ce/bulk`);
};

export const getActivationHistory = (companyType, companyId, queries) => {
  return http('GET', `activation/branch/${companyId}/${companyType}`, queries);
};

// Verify Captcha
export const verifyAuthCaptcha = (captchaType, data) => {
  return http('POST', `auth/captcha?type=${captchaType}`, data);
};

export const resendAuthEmailGuard = (data) => {
  return http('POST', `/auth/2fa/eg-resend`, data);
};

export const postAuthCaptchaVerify = (data) => {
  return http('POST', '/auth/captcha/verify', data);
};

export const postAuthEmail = (data) => {
  return http('POST', '/auth/email', data);
};

export const postAuthPassword = (data) => {
  return http('POST', '/auth/password', data);
};

export const postAuthEmailGuardSend = (data) => {
  return http('POST', '/auth/email-guard/send', data);
};

export const postAuthEmailGuardAlternateSend = (data) => {
  return http('POST', '/auth/email-guard/alternate/send', data);
};

export const postAuthEmailGuardVerify = (data) => {
  return http('POST', '/auth/email-guard/verify', data);
};

export const postAuthAuthenticatorVerify = (data) => {
  return http('POST', '/auth/authenticator/verify', data);
};

export const postAuthForgotPassword = (data) => {
  return http('POST', '/auth/forgot', data);
};

export const getAuthResetPasswordCheck = (data) => {
  return http('POST', 'auth/reset/password/check', data);
};

export const getAuthPasswordBreachCheck = (data) => {
  return http('POST', 'auth/password/breach/check', data);
};

export const postAuthRegistration = (data) => {
  return http('POST', 'auth/registration', data);
};

export const postAuthResendConfirmEmail = (data) => {
  return http('POST', 'auth/resend-confirm-email', data);
};

export const putAuthConfirmation = (data) => {
  return http('PUT', 'auth/confirmation', data);
};

export const getAuthActivateToken = (token) => {
  return http('GET', `auth/activate/${token}`);
};

export const getAuthCEActivateSession = (sessionId) => {
  return http('GET', `auth/ce/activate/${sessionId}`);
};

// AB
export const postAuthActivateToken = (token, formData) => {
  return http('POST', `auth/activate/${token}`, formData);
};

// CB
export const postAuthActivateTokenToken = (token, formData) => {
  return http('POST', `auth/activate/token/${token}`, formData);
};

// CE
export const postAuthActivateCESession = (sessionId, formData) => {
  return http('POST', `auth/ce/registration/${sessionId}`, formData);
};

export const getAuthCeActivate = () => {
  return http('GET', `auth/ce/activate`);
};

export const postAuthCEActivateCeCode = (data) => {
  return http('POST', 'auth/ce/activate/ce-code', data);
};

export const getAuthCeValidate = (code) => {
  return http('GET', `auth/ce/validate-code/${code}`);
};

/**
 * Get BSID Secret
 * @returns nothing
 */
export const getAuthBSIDSecret = () => {
  return http('GET', 'auth/bsid-secret');
};
